import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['container', 'content', 'contentInner', 'icon', 'shadow'];
  static values = {
    open: Boolean,
    openHeight: { type: Number, default: 100 },
  };

  connect() {
    if (this.openValue) {
      this.open();
    }
  }

  toggle() {
    if (this.contentTarget.style.height === '0px') {
      this.open();
    } else {
      this.close();
    }

    // Emite evento customizado para componentes pai poderem reagir
    this.element.dispatchEvent(
      new CustomEvent('accordion-clicked', {
        bubbles: true,
        detail: { accordion: this },
      }),
    );
  }

  open() {
    // Expande o conteúdo suavemente de 0px para a altura configurada
    this.contentTarget.style.height = `${this.openHeightValue}px`;

    // Muda para estilo "selected" (primary colors)
    this.containerTarget.classList.remove(
      'tw-bg-white',
      'tw-border-coolGray-400',
      'hover:tw-bg-coolGray-50',
    );
    this.containerTarget.classList.add('tw-bg-primary-25', 'tw-border-primary-100');

    // Atualiza a sombra
    this.shadowTarget.classList.remove('tw-bg-coolGray-400');
    this.shadowTarget.classList.add('tw-bg-primary-100');

    this.openValue = true;
  }

  close() {
    // Colapsa o conteúdo suavemente para 0px
    this.contentTarget.style.height = '0px';

    // Rotaciona a seta de volta se existir
    if (this.hasIconTarget) {
      this.iconTarget.classList.remove('tw-rotate-180');
    }

    // Muda para estilo "não selected" (coolGray colors)
    this.containerTarget.classList.remove('tw-bg-primary-25', 'tw-border-primary-100');
    this.containerTarget.classList.add(
      'tw-bg-white',
      'tw-border-coolGray-400',
      'hover:tw-bg-coolGray-50',
    );

    // Atualiza a sombra
    this.shadowTarget.classList.add('tw-bg-coolGray-400');
    this.shadowTarget.classList.remove('tw-bg-primary-100');

    this.openValue = false;
  }
}
